import { useEffect } from "react";

const SITE = "https://imyourman.de";

function upsertMeta(selector, attr, key, content) {
  let el = document.head.querySelector(selector);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
}

function upsertCanonical(href) {
  let el = document.head.querySelector('link[rel="canonical"]');
  if (!el) {
    el = document.createElement("link");
    el.setAttribute("rel", "canonical");
    document.head.appendChild(el);
  }
  el.setAttribute("href", href);
}

/**
 * Lightweight per-route SEO: sets title, description, canonical and OG/Twitter
 * tags on mount. Dependency-free (works with Google's JS rendering).
 */
export default function useSeo({ title, description, path = "/", robots }) {
  useEffect(() => {
    const url = SITE + path;
    if (title) {
      document.title = title;
      upsertMeta('meta[property="og:title"]', "property", "og:title", title);
      upsertMeta('meta[name="twitter:title"]', "name", "twitter:title", title);
    }
    if (description) {
      upsertMeta('meta[name="description"]', "name", "description", description);
      upsertMeta('meta[property="og:description"]', "property", "og:description", description);
      upsertMeta('meta[name="twitter:description"]', "name", "twitter:description", description);
    }
    upsertMeta('meta[property="og:url"]', "property", "og:url", url);
    upsertCanonical(url);
    if (robots) {
      upsertMeta('meta[name="robots"]', "name", "robots", robots);
    }
  }, [title, description, path, robots]);
}
